import axios from "axios";
import { useEffect, useState } from "react";
import { getRatePlansByRoom } from "../getRatePlansByRoom";

export const useRoomsAndRatePlans = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [duplicaterooms, setDuplicaterooms] = useState([]);
  const [ratePlans, setRatePlans] = useState({});
  const [showSidebar, setShowSidebar] = useState(true);

  useEffect(() => {
    const fetchRoomsAndRatePlans = async () => {
      try {
        setLoading(true);
        const [roomsResponse, ratePlansResponse] = await Promise.all([
          axios.get("/api/rooms/getallrooms"),
          axios.get("/api/rateplans/getallrateplans"),
        ]);
        setRooms(roomsResponse.data);
        setDuplicaterooms(roomsResponse.data);
        setRatePlans(getRatePlansByRoom(ratePlansResponse));
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
        console.log(error);
      }
    };

    fetchRoomsAndRatePlans();
  }, []);

  return {
    rooms,
    loading,
    error,
    duplicaterooms,
    ratePlans,
    showSidebar,
    setShowSidebar,
    setRooms,
  };
};
